<template>
  <form
      :class="{'nx-active': active}"
      :data-vv-scope="scope"
      :id="'scope-' + scope"
      class="nx-form">
    <h2 class="nx-form-legend mb-1 mt-2"
        v-html="$t('message.form.scopes.' + scope)"
        v-if="scope"
    ></h2>
    <div class="nx-form-fieldset">

      <nx-form-text
          name="title"
          validation="required"
          :label="$t('message.form.fields.title')"
          :value="draft.title"
          :disabled="disabled"
      ></nx-form-text>

      <nx-form-text
          name="subtitle"
          :label="$t('message.form.fields.subtitle')"
          :value="draft.subtitle"
          :disabled="disabled"
      ></nx-form-text>

      <nx-form-text
          name="kicker"
          validation="required"
          :label="$t('message.form.fields.kicker')"
          :value="draft.kicker"
          :disabled="disabled"
      ></nx-form-text>

      <nx-form-text-editor
          name="summary"
          :label="$t('message.form.fields.summary')"
          :value="draft.summary"
          :disabled="disabled"
      ></nx-form-text-editor>

      <nx-form-content-editor
          name="body"
          validation="required"
          :label="$t('message.form.fields.body')"
          :value="draft.body"
          :counter="true"
          :disabled="disabled"
      ></nx-form-content-editor>
    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import FormTextEditor from '@/modules/form/components/FormTextEditor';
import FormContentEditor from '@/modules/form/components/FormContentEditor';

export default {
  name: 'nx-form-content',
  extends: FormScope,
  components: {
    [FormTextEditor.name]: FormTextEditor,
    [FormContentEditor.name]: FormContentEditor,
  },
};
</script>
